"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const native_1 = require("@react-navigation/native");
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const store_1 = require("../../../store");
const spinner_1 = __importDefault(require("../../../components/spinner/spinner"));
const uploadFile_1 = __importDefault(require("./uploadFile"));
const acceptDecline_1 = __importDefault(require("./acceptDecline"));
const surveySlice_1 = require("../surveySlice");
const appMessages_1 = __importDefault(require("../../../components/appMessage/appMessages"));
const styles_1 = __importDefault(require("../../../styles/styles"));
const screenConstants_1 = require("../../../constants/screenConstants");
const analytics_1 = require("../../../utils/analytics/analytics");
const AcceptDeclineBase = ({ navigation }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const { params } = (0, native_1.useRoute)();
    const [showUpload, setShowUpload] = (0, react_1.useState)(params.has_upload === 'True');
    const [data, setData] = (0, react_1.useState)();
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const getData = async () => {
        setIsLoading(true);
        const result = await dispatch((0, surveySlice_1.getDocumentData)({ document_type: params.document_type }));
        logEventWithExtraProperties('api_call', {
            name: 'get_document_data',
            status: 'submitted',
            location: 'screen_AcceptDeclineBase',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'get_document_data',
                status: 'success',
                location: 'screen_AcceptDeclineBase',
            });
            setErrors(undefined);
            setData(result.payload);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'get_document_data',
                status: 'fail',
                location: 'screen_AcceptDeclineBase',
            });
            setErrors(result.payload);
        }
        setIsLoading(false);
    };
    (0, react_1.useEffect)(() => {
        getData();
    }, []);
    let content = react_1.default.createElement(react_native_1.View, null);
    if (data) {
        if (showUpload) {
            content = (react_1.default.createElement(uploadFile_1.default, { loanApplicationId: data.loan_application_id, documentType: params.document_type, setShowUpload: setShowUpload, errors: errors }));
        }
        else {
            content = (react_1.default.createElement(acceptDecline_1.default, { loanApplicationId: data.loan_application_id, documentType: params.document_type, documentUrl: data.document_url, errors: errors, specialNavigation: () => navigation.navigate(screenConstants_1.HOME_SCREEN) }));
        }
    }
    return (react_1.default.createElement(appMessages_1.default, { isHomeContainer: false }, isLoading ? (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.centerChildHorizontalVertical, styles_1.default.flexOne] },
        react_1.default.createElement(spinner_1.default, null))) : (react_1.default.createElement(react_1.default.Fragment, null, content))));
};
exports.default = AcceptDeclineBase;
